import _slicedToArray from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/Users/macbook/Desktop/GitHub/4d_synth/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { copyFromChannel } from '../helpers/copy-from-channel';
import { copyToChannel } from '../helpers/copy-to-channel';
import { createNestedArrays } from '../helpers/create-nested-arrays';
import { getAudioNodeConnections } from '../helpers/get-audio-node-connections';
import { getAudioWorkletProcessor } from '../helpers/get-audio-worklet-processor';
import { isOwnedByContext } from '../helpers/is-owned-by-context';

var processBuffer = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(proxy, renderedBuffer, nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime) {
    var length, numberOfInputChannels, numberOfOutputChannels, processedBuffer, audioNodeConnections, audioWorkletProcessor, inputs, outputs, parameters, _loop, i, _ret;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Ceil the length to the next full render quantum.
            // Bug #17: Safari does not yet expose the length.
            length = renderedBuffer === null ? Math.ceil(proxy.context.length / 128) * 128 : renderedBuffer.length;
            numberOfInputChannels = options.channelCount * options.numberOfInputs;
            numberOfOutputChannels = outputChannelCount.reduce(function (sum, value) {
              return sum + value;
            }, 0);
            processedBuffer = numberOfOutputChannels === 0 ? null : nativeOfflineAudioContext.createBuffer(numberOfOutputChannels, length, nativeOfflineAudioContext.sampleRate);

            if (!(processorConstructor === undefined)) {
              _context.next = 6;
              break;
            }

            throw new Error('Missing the processor constructor.');

          case 6:
            audioNodeConnections = getAudioNodeConnections(proxy);
            _context.next = 9;
            return getAudioWorkletProcessor(nativeOfflineAudioContext, proxy);

          case 9:
            audioWorkletProcessor = _context.sent;
            inputs = createNestedArrays(options.numberOfInputs, options.channelCount);
            outputs = createNestedArrays(options.numberOfOutputs, outputChannelCount);
            parameters = Array.from(proxy.parameters.keys()).reduce(function (prmtrs, name) {
              return _objectSpread(_objectSpread({}, prmtrs), {}, _defineProperty({}, name, new Float32Array(128)));
            }, {});

            _loop = function _loop(i) {
              if (options.numberOfInputs > 0 && renderedBuffer !== null) {
                for (var j = 0; j < options.numberOfInputs; j += 1) {
                  for (var k = 0; k < options.channelCount; k += 1) {
                    copyFromChannel(renderedBuffer, inputs[j], k, k, i);
                  }
                }
              }

              if (processorConstructor.parameterDescriptors !== undefined && renderedBuffer !== null) {
                processorConstructor.parameterDescriptors.forEach(function (_ref2, index) {
                  var name = _ref2.name;
                  copyFromChannel(renderedBuffer, parameters, name, numberOfInputChannels + index, i);
                });
              }

              for (var _j = 0; _j < options.numberOfInputs; _j += 1) {
                for (var _k = 0; _k < outputChannelCount[_j]; _k += 1) {
                  // The byteLength will be 0 when the ArrayBuffer was transferred.
                  if (outputs[_j][_k].byteLength === 0) {
                    outputs[_j][_k] = new Float32Array(128);
                  }
                }
              }

              try {
                var potentiallyEmptyInputs = inputs.map(function (input, index) {
                  if (audioNodeConnections.activeInputs[index].size === 0) {
                    return [];
                  }

                  return input;
                });
                var activeSourceFlag = exposeCurrentFrameAndCurrentTime(i / nativeOfflineAudioContext.sampleRate, nativeOfflineAudioContext.sampleRate, function () {
                  return audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters);
                });

                if (processedBuffer !== null) {
                  for (var _j2 = 0, outputChannelSplitterNodeOutput = 0; _j2 < options.numberOfOutputs; _j2 += 1) {
                    for (var _k2 = 0; _k2 < outputChannelCount[_j2]; _k2 += 1) {
                      copyToChannel(processedBuffer, outputs[_j2], _k2, outputChannelSplitterNodeOutput + _k2, i);
                    }

                    outputChannelSplitterNodeOutput += outputChannelCount[_j2];
                  }
                }

                if (!activeSourceFlag) {
                  return "break";
                }
              } catch (error) {
                proxy.dispatchEvent(new ErrorEvent('processorerror', {
                  colno: error.colno,
                  filename: error.filename,
                  lineno: error.lineno,
                  message: error.message
                }));
                return "break";
              }
            };

            i = 0;

          case 15:
            if (!(i < length)) {
              _context.next = 22;
              break;
            }

            _ret = _loop(i);

            if (!(_ret === "break")) {
              _context.next = 19;
              break;
            }

            return _context.abrupt("break", 22);

          case 19:
            i += 128;
            _context.next = 15;
            break;

          case 22:
            return _context.abrupt("return", processedBuffer);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function processBuffer(_x, _x2, _x3, _x4, _x5, _x6, _x7) {
    return _ref.apply(this, arguments);
  };
}();

export var createAudioWorkletNodeRendererFactory = function createAudioWorkletNodeRendererFactory(connectAudioParam, connectMultipleOutputs, createNativeAudioBufferSourceNode, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, deleteUnrenderedAudioWorkletNode, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getNativeAudioNode, nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext) {
  return function (name, options, processorConstructor) {
    var renderedNativeAudioNodes = new WeakMap();
    var processedBufferPromise = null;

    var createAudioNode = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(proxy, nativeOfflineAudioContext, trace) {
        var nativeAudioWorkletNode, nativeOutputNodes, nativeAudioWorkletNodeIsOwnedByContext, outputChannelCount, numberOfOutputChannels, outputChannelSplitterNode, outputChannelMergerNodes, i, outputGainNode, _numberOfInputChannels, numberOfParameters, numberOfChannels, renderBuffer, _processedBuffer, audioBufferSourceNode, _nativeOutputNodes, _nativeOutputNodes2, _outputChannelSplitterNode, _outputChannelMergerNodes, _outputGainNode, _i3, outputChannelSplitterNodeOutput, outputChannelMergerNode, j, _iterator2, _step2, _step2$value, nm, audioParam, _iterator3, _step3, _step3$value, _nm, _audioParam;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                nativeAudioWorkletNode = getNativeAudioNode(proxy);
                nativeOutputNodes = null;
                nativeAudioWorkletNodeIsOwnedByContext = isOwnedByContext(nativeAudioWorkletNode, nativeOfflineAudioContext);
                outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount); // Bug #61: Only Chrome, Edge, Firefox & Opera have an implementation of the AudioWorkletNode yet.

                if (nativeAudioWorkletNodeConstructor === null) {
                  numberOfOutputChannels = outputChannelCount.reduce(function (sum, value) {
                    return sum + value;
                  }, 0);
                  outputChannelSplitterNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, {
                    channelCount: Math.max(1, numberOfOutputChannels),
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    numberOfOutputs: Math.max(1, numberOfOutputChannels)
                  });
                  outputChannelMergerNodes = [];

                  for (i = 0; i < proxy.numberOfOutputs; i += 1) {
                    outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeOfflineAudioContext, {
                      channelCount: 1,
                      channelCountMode: 'explicit',
                      channelInterpretation: 'speakers',
                      numberOfInputs: outputChannelCount[i]
                    }));
                  }

                  outputGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    channelCount: options.channelCount,
                    channelCountMode: options.channelCountMode,
                    channelInterpretation: options.channelInterpretation,
                    gain: 1
                  });
                  outputGainNode.connect = connectMultipleOutputs.bind(null, outputChannelMergerNodes);
                  outputGainNode.disconnect = disconnectMultipleOutputs.bind(null, outputChannelMergerNodes);
                  nativeOutputNodes = [outputChannelSplitterNode, outputChannelMergerNodes, outputGainNode];
                } else if (!nativeAudioWorkletNodeIsOwnedByContext) {
                  nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeOfflineAudioContext, name);
                }

                renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeOutputNodes === null ? nativeAudioWorkletNode : nativeOutputNodes[2]);

                if (!(nativeOutputNodes !== null)) {
                  _context4.next = 41;
                  break;
                }

                if (!(processedBufferPromise === null)) {
                  _context4.next = 32;
                  break;
                }

                if (!(processorConstructor === undefined)) {
                  _context4.next = 10;
                  break;
                }

                throw new Error('Missing the processor constructor.');

              case 10:
                if (!(nativeOfflineAudioContextConstructor === null)) {
                  _context4.next = 12;
                  break;
                }

                throw new Error('Missing the native OfflineAudioContext constructor.');

              case 12:
                // Bug #47: The AudioDestinationNode in Safari gets not initialized correctly.
                _numberOfInputChannels = proxy.channelCount * proxy.numberOfInputs;
                numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length;
                numberOfChannels = _numberOfInputChannels + numberOfParameters;

                renderBuffer = /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
                    var partialOfflineAudioContext, gainNodes, inputChannelSplitterNodes, _i, constantSourceNodes, inputChannelMergerNode, _i2, j, _iterator, _step, _step$value, index, constantSourceNode;

                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(numberOfChannels, // Ceil the length to the next full render quantum.
                            // Bug #17: Safari does not yet expose the length.
                            Math.ceil(proxy.context.length / 128) * 128, nativeOfflineAudioContext.sampleRate);
                            gainNodes = [];
                            inputChannelSplitterNodes = [];

                            for (_i = 0; _i < options.numberOfInputs; _i += 1) {
                              gainNodes.push(createNativeGainNode(partialOfflineAudioContext, {
                                channelCount: options.channelCount,
                                channelCountMode: options.channelCountMode,
                                channelInterpretation: options.channelInterpretation,
                                gain: 1
                              }));
                              inputChannelSplitterNodes.push(createNativeChannelSplitterNode(partialOfflineAudioContext, {
                                channelCount: options.channelCount,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'discrete',
                                numberOfOutputs: options.channelCount
                              }));
                            }

                            _context3.next = 6;
                            return Promise.all(Array.from(proxy.parameters.values()).map( /*#__PURE__*/function () {
                              var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(audioParam) {
                                var constantSourceNode;
                                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        constantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                                          channelCount: 1,
                                          channelCountMode: 'explicit',
                                          channelInterpretation: 'discrete',
                                          offset: audioParam.value
                                        });
                                        _context2.next = 3;
                                        return renderAutomation(partialOfflineAudioContext, audioParam, constantSourceNode.offset, trace);

                                      case 3:
                                        return _context2.abrupt("return", constantSourceNode);

                                      case 4:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2);
                              }));

                              return function (_x11) {
                                return _ref5.apply(this, arguments);
                              };
                            }()));

                          case 6:
                            constantSourceNodes = _context3.sent;
                            inputChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                              channelCount: 1,
                              channelCountMode: 'explicit',
                              channelInterpretation: 'speakers',
                              numberOfInputs: Math.max(1, _numberOfInputChannels + numberOfParameters)
                            });

                            for (_i2 = 0; _i2 < options.numberOfInputs; _i2 += 1) {
                              gainNodes[_i2].connect(inputChannelSplitterNodes[_i2]);

                              for (j = 0; j < options.channelCount; j += 1) {
                                inputChannelSplitterNodes[_i2].connect(inputChannelMergerNode, j, _i2 * options.channelCount + j);
                              }
                            }

                            _iterator = _createForOfIteratorHelper(constantSourceNodes.entries());

                            try {
                              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                                _step$value = _slicedToArray(_step.value, 2), index = _step$value[0], constantSourceNode = _step$value[1];
                                constantSourceNode.connect(inputChannelMergerNode, 0, _numberOfInputChannels + index);
                                constantSourceNode.start(0);
                              }
                            } catch (err) {
                              _iterator.e(err);
                            } finally {
                              _iterator.f();
                            }

                            inputChannelMergerNode.connect(partialOfflineAudioContext.destination);
                            _context3.next = 14;
                            return Promise.all(gainNodes.map(function (gainNode) {
                              return renderInputsOfAudioNode(proxy, partialOfflineAudioContext, gainNode, trace);
                            }));

                          case 14:
                            return _context3.abrupt("return", renderNativeOfflineAudioContext(partialOfflineAudioContext));

                          case 15:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function renderBuffer() {
                    return _ref4.apply(this, arguments);
                  };
                }();

                _context4.t0 = processBuffer;
                _context4.t1 = proxy;

                if (!(numberOfChannels === 0)) {
                  _context4.next = 22;
                  break;
                }

                _context4.t2 = null;
                _context4.next = 25;
                break;

              case 22:
                _context4.next = 24;
                return renderBuffer();

              case 24:
                _context4.t2 = _context4.sent;

              case 25:
                _context4.t3 = _context4.t2;
                _context4.t4 = nativeOfflineAudioContext;
                _context4.t5 = options;
                _context4.t6 = outputChannelCount;
                _context4.t7 = processorConstructor;
                _context4.t8 = exposeCurrentFrameAndCurrentTime;
                processedBufferPromise = (0, _context4.t0)(_context4.t1, _context4.t3, _context4.t4, _context4.t5, _context4.t6, _context4.t7, _context4.t8);

              case 32:
                _context4.next = 34;
                return processedBufferPromise;

              case 34:
                _processedBuffer = _context4.sent;
                audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, {
                  buffer: null,
                  channelCount: 2,
                  channelCountMode: 'max',
                  channelInterpretation: 'speakers',
                  loop: false,
                  loopEnd: 0,
                  loopStart: 0,
                  playbackRate: 1
                });
                _nativeOutputNodes = nativeOutputNodes, _nativeOutputNodes2 = _slicedToArray(_nativeOutputNodes, 3), _outputChannelSplitterNode = _nativeOutputNodes2[0], _outputChannelMergerNodes = _nativeOutputNodes2[1], _outputGainNode = _nativeOutputNodes2[2];

                if (_processedBuffer !== null) {
                  audioBufferSourceNode.buffer = _processedBuffer;
                  audioBufferSourceNode.start(0);
                }

                audioBufferSourceNode.connect(_outputChannelSplitterNode);

                for (_i3 = 0, outputChannelSplitterNodeOutput = 0; _i3 < proxy.numberOfOutputs; _i3 += 1) {
                  outputChannelMergerNode = _outputChannelMergerNodes[_i3];

                  for (j = 0; j < outputChannelCount[_i3]; j += 1) {
                    _outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                  }

                  outputChannelSplitterNodeOutput += outputChannelCount[_i3];
                }

                return _context4.abrupt("return", _outputGainNode);

              case 41:
                if (nativeAudioWorkletNodeIsOwnedByContext) {
                  _context4.next = 61;
                  break;
                }

                _iterator2 = _createForOfIteratorHelper(proxy.parameters.entries());
                _context4.prev = 43;

                _iterator2.s();

              case 45:
                if ((_step2 = _iterator2.n()).done) {
                  _context4.next = 51;
                  break;
                }

                _step2$value = _slicedToArray(_step2.value, 2), nm = _step2$value[0], audioParam = _step2$value[1];
                _context4.next = 49;
                return renderAutomation(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
                nativeAudioWorkletNode.parameters.get(nm), trace);

              case 49:
                _context4.next = 45;
                break;

              case 51:
                _context4.next = 56;
                break;

              case 53:
                _context4.prev = 53;
                _context4.t9 = _context4["catch"](43);

                _iterator2.e(_context4.t9);

              case 56:
                _context4.prev = 56;

                _iterator2.f();

                return _context4.finish(56);

              case 59:
                _context4.next = 78;
                break;

              case 61:
                _iterator3 = _createForOfIteratorHelper(proxy.parameters.entries());
                _context4.prev = 62;

                _iterator3.s();

              case 64:
                if ((_step3 = _iterator3.n()).done) {
                  _context4.next = 70;
                  break;
                }

                _step3$value = _slicedToArray(_step3.value, 2), _nm = _step3$value[0], _audioParam = _step3$value[1];
                _context4.next = 68;
                return connectAudioParam(nativeOfflineAudioContext, _audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
                nativeAudioWorkletNode.parameters.get(_nm), trace);

              case 68:
                _context4.next = 64;
                break;

              case 70:
                _context4.next = 75;
                break;

              case 72:
                _context4.prev = 72;
                _context4.t10 = _context4["catch"](62);

                _iterator3.e(_context4.t10);

              case 75:
                _context4.prev = 75;

                _iterator3.f();

                return _context4.finish(75);

              case 78:
                _context4.next = 80;
                return renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioWorkletNode, trace);

              case 80:
                return _context4.abrupt("return", nativeAudioWorkletNode);

              case 81:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[43, 53, 56, 59], [62, 72, 75, 78]]);
      }));

      return function createAudioNode(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      };
    }();

    return {
      render: function render(proxy, nativeOfflineAudioContext, trace) {
        deleteUnrenderedAudioWorkletNode(nativeOfflineAudioContext, proxy);
        var renderedNativeAudioWorkletNodeOrGainNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);

        if (renderedNativeAudioWorkletNodeOrGainNode !== undefined) {
          return Promise.resolve(renderedNativeAudioWorkletNodeOrGainNode);
        }

        return createAudioNode(proxy, nativeOfflineAudioContext, trace);
      }
    };
  };
};